import { RouteRecordRaw } from 'vue-router'
import { registersRoutes } from '@/modules/registers'

const SignUpLayout = () =>
  import(
    /* webpackChunkName: "register-layout" */ '@/core/layouts/RegisterLayout.vue'
  )

const TermsConditions = () =>
  import(
    /* webpackChunkName: "terminos-y-condiciones" */ '@/core/pages/TermsConditions.vue'
  )

const Privacy = () =>
  import(/* webpackChunkName: "privacy" */ '@/core/pages/Privacy.vue')

export const signUpRoutes: Array<RouteRecordRaw> = [
  {
    path: '/register',
    component: SignUpLayout,
    redirect: '/registers',
    children: [...registersRoutes],
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: TermsConditions,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
  },
]
